var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-inline-flex mb-4" }, [
        _vm.sound_fields.length
          ? _c("div", { staticClass: "form-check mr-3" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectAll,
                    expression: "selectAll"
                  }
                ],
                staticClass: "form-check-input select-all mt-0",
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.selectAll)
                    ? _vm._i(_vm.selectAll, null) > -1
                    : _vm.selectAll
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.selectAll,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.selectAll = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.selectAll = $$c
                    }
                  }
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("h4", { staticClass: "mr-3 mb-0" }, [_vm._v("\n      Sound\n    ")]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("span", { staticClass: "cursor-pointer" }, [
            _c("img", {
              staticClass: "heading-icon",
              attrs: { src: require("@/assets/addplus_icon.svg"), width: "20" },
              on: { click: _vm.showAddNewSoundModal }
            })
          ]),
          _vm._v(" "),
          _vm.sound_fields.length && _vm.isSelected
            ? _c(
                "span",
                {
                  staticClass: "cursor-pointer ml-3",
                  on: {
                    click: function($event) {
                      return _vm.deleteAllSound()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-trash" })]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.sound_fields, function(sounditem, index) {
        return _c("div", { key: index, staticClass: "mb-3" }, [
          _c(
            "div",
            { staticClass: "fields-wrapper is-divider is-multi-node" },
            [
              _c("div", { staticClass: "form-check select-single" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: sounditem.sound.selectSingle,
                      expression: "sounditem.sound.selectSingle"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(sounditem.sound.selectSingle)
                      ? _vm._i(sounditem.sound.selectSingle, null) > -1
                      : sounditem.sound.selectSingle
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = sounditem.sound.selectSingle,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                sounditem.sound,
                                "selectSingle",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                sounditem.sound,
                                "selectSingle",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(sounditem.sound, "selectSingle", $$c)
                        }
                      },
                      _vm.checkSingleSelect
                    ]
                  }
                })
              ]),
              _vm._v(" "),
              !sounditem.sound.isCopied || sounditem.sound.selectSingle
                ? _c("div", { staticClass: "action-buttons" }, [
                    !sounditem.sound.isCopied
                      ? _c(
                          "span",
                          {
                            staticClass: "action-item ",
                            on: {
                              click: function($event) {
                                return _vm.copySound(index, sounditem)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-copy" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    sounditem.sound.selectSingle
                      ? _c(
                          "span",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function($event) {
                                return _vm.deleteSound(index, sounditem)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-trash" })]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-6" }, [
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-3 col-form-label",
                          attrs: { for: "animation_selector" }
                        },
                        [_vm._v("\n              Sound Selector\n            ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: sounditem.sound.mediaId,
                                expression: "sounditem.sound.mediaId"
                              }
                            ],
                            staticClass: "custom-select",
                            attrs: { id: "animation_selector" },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    sounditem.sound,
                                    "mediaId",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  return _vm.changeSelectedSound(
                                    index,
                                    sounditem.sound
                                  )
                                }
                              ]
                            }
                          },
                          _vm._l(_vm.sounds, function(soundSelector, key) {
                            return _c(
                              "option",
                              {
                                key: key,
                                staticClass: "custom-select",
                                domProps: { value: key }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(soundSelector.name) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v("\n              Sound Type\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: sounditem.sound.soundType,
                                expression: "sounditem.sound.soundType"
                              }
                            ],
                            staticClass: "custom-select",
                            attrs: { placeholder: "Select Sound Type" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  sounditem.sound,
                                  "soundType",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "2D" } }, [
                              _vm._v("2D")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "3D" } }, [
                              _vm._v("3D")
                            ])
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-3 col-form-label",
                          attrs: { for: "start_time" }
                        },
                        [_vm._v("\n              Start Time\n            ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: sounditem.sound.startTime,
                              expression: "sounditem.sound.startTime"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number", id: "start_time" },
                          domProps: { value: sounditem.sound.startTime },
                          on: {
                            change: function($event) {
                              return _vm.setDuration(index)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                sounditem.sound,
                                "startTime",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-3 col-form-label",
                          attrs: { for: "end_time" }
                        },
                        [_vm._v("\n              End Time\n            ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: sounditem.sound.endTime,
                              expression: "sounditem.sound.endTime"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number", id: "end_time" },
                          domProps: { value: sounditem.sound.endTime },
                          on: {
                            change: function($event) {
                              return _vm.setDuration(index)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                sounditem.sound,
                                "endTime",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v("\n              Duration\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          staticClass: "form-control",
                          attrs: {
                            type: "number",
                            id: "animation_duration_e",
                            readonly: ""
                          },
                          domProps: {
                            value: (
                              sounditem.sound.endTime -
                              sounditem.sound.startTime
                            ).toFixed(2)
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v("\n              Spatial Blend\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: sounditem.sound.spatialBlend,
                              expression: "sounditem.sound.spatialBlend"
                            }
                          ],
                          attrs: {
                            type: "range",
                            min: "0",
                            max: "1",
                            step: "0.5"
                          },
                          domProps: { value: sounditem.sound.spatialBlend },
                          on: {
                            __r: function($event) {
                              return _vm.$set(
                                sounditem.sound,
                                "spatialBlend",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-2" }, [
                          _vm._v(_vm._s(sounditem.sound.spatialBlend))
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6" }, [
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-3 col-form-label",
                          attrs: { for: "select_audio" }
                        },
                        [_vm._v("\n              Audio Options\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-9" },
                        [
                          !sounditem.sound.hasOwnProperty("isAudioPlaying") ||
                          !sounditem.sound.isAudioPlaying
                            ? [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-success",
                                    attrs: { id: "select_audio_duration_s" },
                                    on: {
                                      click: function($event) {
                                        return _vm.playSelectedSound(index)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-play" })]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          sounditem.sound.hasOwnProperty("isAudioPlaying") &&
                          sounditem.sound.isAudioPlaying
                            ? [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-warning",
                                    attrs: {
                                      id: "select_audio_duration_pause"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pauseSelectedSound(index)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-pause pause"
                                    })
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-danger ml-4",
                              attrs: { id: "select_audio_duration_stop" },
                              on: {
                                click: function($event) {
                                  return _vm.stopSelectedSound(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-stop" })]
                          )
                        ],
                        2
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v("\n              Loop count\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: sounditem.sound.loopCount,
                              expression: "sounditem.sound.loopCount"
                            }
                          ],
                          attrs: {
                            type: "range",
                            min: "0",
                            max: "10",
                            step: "0.5"
                          },
                          domProps: { value: sounditem.sound.loopCount },
                          on: {
                            __r: function($event) {
                              return _vm.$set(
                                sounditem.sound,
                                "loopCount",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-2" }, [
                          _vm._v(_vm._s(sounditem.sound.loopCount))
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v("\n              Volume\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: sounditem.sound.volume,
                              expression: "sounditem.sound.volume"
                            }
                          ],
                          attrs: {
                            type: "range",
                            min: "0",
                            max: "10",
                            step: "0.5"
                          },
                          domProps: { value: sounditem.sound.volume },
                          on: {
                            change: function($event) {
                              return _vm.updateVolume(index)
                            },
                            __r: function($event) {
                              return _vm.$set(
                                sounditem.sound,
                                "volume",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-2" }, [
                          _vm._v(_vm._s(sounditem.sound.volume))
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v("\n              Pitch\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: sounditem.sound.pitch,
                              expression: "sounditem.sound.pitch"
                            }
                          ],
                          attrs: {
                            type: "range",
                            min: "0",
                            max: "10",
                            step: "0.5"
                          },
                          domProps: { value: sounditem.sound.pitch },
                          on: {
                            __r: function($event) {
                              return _vm.$set(
                                sounditem.sound,
                                "pitch",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-2" }, [
                          _vm._v(_vm._s(sounditem.sound.pitch))
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v("\n              Minimum Distance\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: sounditem.sound.minimumDistance,
                              expression: "sounditem.sound.minimumDistance"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: { value: sounditem.sound.minimumDistance },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                sounditem.sound,
                                "minimumDistance",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v("\n              Maximum Distance\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: sounditem.sound.maximumDistance,
                              expression: "sounditem.sound.maximumDistance"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: { value: sounditem.sound.maximumDistance },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                sounditem.sound,
                                "maximumDistance",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      }),
      _vm._v(" "),
      _vm.showModal
        ? [
            _c(
              "div",
              {
                staticClass: "modal",
                attrs: {
                  id: "character-modal",
                  tabindex: "-1",
                  role: "dialog",
                  "data-backdrop": "static",
                  "data-keyboard": "false"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-dialog modal-lg",
                    attrs: { role: "document" }
                  },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            "aria-label": "Close"
                          },
                          on: {
                            click: function($event) {
                              return _vm.closeModal()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-body" }, [
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "form-group col-12" }, [
                            _c("p", { staticClass: "font-weight-bold" }, [
                              _vm._v("Select Sound")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "models-wrapper" },
                              _vm._l(_vm.sounds, function(sound, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "model-item" },
                                  [
                                    _c("div", { staticClass: "col-1" }, [
                                      sound.hasOwnProperty("showStopButton") &&
                                      !sound.showStopButton
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-success",
                                              attrs: {
                                                id: "select_audio_duration_s"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.playSound(index)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-play"
                                              })
                                            ]
                                          )
                                        : _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-danger",
                                              attrs: {
                                                id: "select_audio_duration_e"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.stopSound(index)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-stop"
                                              })
                                            ]
                                          )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [_vm._v(_vm._s(sound.name))]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-1" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: {
                                            id: "select_audio_duration_e"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.updatedSelectedSound(
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Select\n                      "
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "text-center font-size-20" }, [
        _vm._v("\n              Sound Modal\n            ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-093607cb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-093607cb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-components/models/sound.vue
// module id = null
// module chunks = 